<div class="min-h-screen bg-gradient-to-br p-2 md:p-6">
  <!-- Titre -->
  <div class="text-center mb-0">
    <app-page-title [titleKey]="'events.title'"></app-page-title>
  </div>
      <app-loader [isLoading]="loading"></app-loader>

<app-children-selector
  [(selectedStudentId)]="selectedStudentId"
  (studentSelected)="onStudentSelected.bind(this)($event)"
></app-children-selector>


<div class="flex justify-center gap-4 my-4">
  <button 
    (click)="setTab('events')" 
    [class.font-bold]="activeTab === 'events'"
    class="px-4 py-2 bg-[#49BBBD] text-white rounded-lg shadow hover:bg-[#3aa3a5] transition">
    {{ 'events.title' | translate }}
  </button>

  <button 
    (click)="setTab('reservations')" 
    [class.font-bold]="activeTab === 'reservations'"
    class="px-4 py-2 bg-[#49BBBD] text-white rounded-lg shadow hover:bg-[#3aa3a5] transition">
    {{ 'events.myReservations' | translate }}
  </button>


</div>


<div *ngIf="activeTab === 'book' && selectedEvent" class="mt-6 p-6 bg-white shadow rounded-lg max-w-md mx-auto">
  <h2 class="text-xl font-bold mb-4">{{ 'events.bookEvent' | translate }}</h2>

  <!-- Nom de l'événement (lecture seule) -->
<div class="mb-4">
  <label class="block font-semibold">{{ 'events.eventName' | translate }}</label>
  <select [(ngModel)]="selectedEvent" class="w-full border rounded px-3 py-2 bg-white">
    <option *ngFor="let event of events" [ngValue]="event">
      {{ event.eventName }}
    </option>
  </select>
</div>


  <!-- Description (modifiable si tu enlèves disabled) -->
  <div class="mb-4">
    <label class="block font-semibold">{{ 'events.description' | translate }}</label>
    <textarea [(ngModel)]="selectedEvent.description" 
              class="w-full border rounded px-3 py-2"
              placeholder="{{ 'events.enterDescription' | translate }}"></textarea>
  </div>

  <!-- Sélection des enfants -->
<div *ngFor="let child of children" class="child-item">
  <input type="checkbox" 
         [checked]="child.selected" 
         (change)="selectChild(child)" 
         class="mr-2" />
  <span>{{ child.nameStudent }}</span>
</div>






</div>


  <!-- Table des réservations -->
<div class="overflow-x-auto w-full mt-6" *ngIf="activeTab === 'reservations'">
<table class="min-w-full shadow-md rounded-lg overflow-hidden">
  <thead class="bg-[#49BBBD]">
    <tr>
<th class="py-2 px-4 text-left text-white">{{ 'events.eventName' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'events.category' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'events.creationDate' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'events.description' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'actions.action' | translate }}</th>

    </tr>
  </thead>
  <tbody class="bg-white">
    <tr *ngFor="let res of paginatedReservations" class="border-b hover:bg-gray-100">
      <td class="py-2 px-4" [attr.data-label]="'events.eventName' | translate">{{ res.event.eventName || '—' }}</td>
      <td class="py-2 px-4" [attr.data-label]="'events.category' | translate">{{ res.event.eventCategory.categoryName || '—' }}</td>
      <td class="py-2 px-4" [attr.data-label]="'events.creationDate' | translate">{{ res.creationDate ? (res.creationDate | date:'shortDate') : '—' }}</td>
      <td class="py-2 px-4" [attr.data-label]="'events.description' | translate">{{ res.description || '—' }}</td>

      <td class="py-2 px-4 flex flex-wrap gap-2">
        <!-- Bouton Image -->
        <button *ngIf="res.event.pathImage"
                (click)="viewPdf(res.event.pathImage)"
                class="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600">
          {{ 'events.imagePDF' | translate }}
        </button>

        <!-- Bouton Programme -->
        <button *ngIf="res.event.pathProgram"
                (click)="viewPdf(res.event.pathProgram)"
                class="px-2 py-1 bg-green-500 text-white rounded hover:bg-green-600">
          {{ 'events.programPDF' | translate }}
        </button>

        <!-- Bouton Supprimer -->
    <button (click)="supprimerReservation(res)" 
        class="px-3 py-1 bg-[#E32B0E] text-white rounded flex items-center gap-2 hover:bg-[#C1270C]" 
        [title]="'events.deleteReservation' | translate">
  <!-- Texte Supprimer -->
  <span>{{ 'events.deleteReservation' | translate }}</span>

  <!-- Icône poubelle à droite -->
  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
    <path stroke-linecap="round" stroke-linejoin="round" 
      d="M3 6h18M9 6v12m6-12v12M5 6l1 14a2 2 0 002 2h8a2 2 0 002-2l1-14M10 6h4"/>
  </svg>
</button>


      </td>
    </tr>
  </tbody>
</table>
</div>

<!-- Pagination Réservations -->
<div *ngIf="activeTab === 'reservations'" class="flex justify-center items-center space-x-1 mt-4">
  <button (click)="previousReservationsPage()"
          [disabled]="reservationsCurrentPage === 1"
          class="w-9 h-9 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
    <svg class="w-4 h-4 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
    </svg>
  </button>

  <ng-container *ngFor="let p of getVisibleReservationPages()">
    <span *ngIf="p === '...'" class="w-9 h-9 flex items-center justify-center text-gray-500">...</span>
    <button *ngIf="p !== '...'"
            (click)="goToReservationsPage(+p)"
            [class]="reservationsCurrentPage === +p
              ? 'w-9 h-9 flex items-center justify-center rounded-md bg-[#009688] text-white font-bold border border-[#009688]'
              : 'w-9 h-9 flex items-center justify-center rounded-md bg-white text-black border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors'">
      {{ p }}
    </button>
  </ng-container>

  <button (click)="nextReservationsPage()"
          [disabled]="reservationsCurrentPage === reservationsTotalPages"
          class="w-9 h-9 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
    <svg class="w-4 h-4 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
    </svg>
  </button>
</div>



  <!-- Table des événements -->
<div class="overflow-x-auto w-full mt-6" *ngIf="activeTab === 'events'">
  <table class="min-w-full shadow-md rounded-lg overflow-hidden">
<thead class="bg-[#49BBBD]">
      <tr>
<th class="py-2 px-4 text-left text-white">{{ 'events.eventName' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'events.totalPlaces' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'events.remainingPlaces' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'events.category' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'events.description' | translate }}</th>
<th class="py-2 px-4 text-left text-white">{{ 'events.dates' | translate }}</th>
<!-- <th class="py-2 px-4 text-left text-white">{{ 'events.classes' | translate }}</th> -->
<th class="py-2 px-4 text-left text-white">{{ 'actions.action' | translate }}</th>

      </tr>
    </thead>
    <tbody class="bg-white">
      <tr *ngFor="let event of paginatedEvents" class="border-b hover:bg-gray-100">
        <td class="py-2 px-4" [attr.data-label]="'events.eventName' | translate">{{ event.eventName }}</td>
        <td class="py-2 px-4" [attr.data-label]="'events.totalPlaces' | translate">{{ event.nbrplace }}</td>
        <td class="py-2 px-4" [attr.data-label]="'events.remainingPlaces' | translate">{{ event.resteplace }}</td>
        <td class="py-2 px-4" [attr.data-label]="'events.category' | translate">{{ event.eventCategory.categoryName }}</td>
        <td class="py-2 px-4" [attr.data-label]="'events.description' | translate">{{ event.description || '-' }}</td>
        <td class="py-2 px-4" [attr.data-label]="'events.dates' | translate">{{ event.startDate }} → {{ event.endDate }}</td>
        <!-- <td class="py-2 px-4">
          <span *ngFor="let batch of event.batchs.batch; let i = index">
            {{ batch.batchname }}<span *ngIf="i < event.batchs.batch.length - 1">, </span>
          </span>
        </td> -->
<td class="py-2 px-4 flex flex-wrap gap-2 items-center">
  <!-- Bouton Télécharger Image -->
  <button *ngIf="event.pathImage"
          (click)="viewPdf(event.pathImage)" 
          class="px-3 py-2 bg-[#E0EEFF] text-[#49BBBD] font-semibold lowercase tracking-wide 
                 rounded-lg hover:bg-[#c8dcff] flex items-center gap-2 shadow-md">
    <span>{{ 'events.image' | translate }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" 
         viewBox="0 0 24 24" stroke="#49BBBD">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
            d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"/>
    </svg>
  </button>

  <!-- Bouton Télécharger Programme -->
  <button *ngIf="event.pathProgram"
          (click)="viewPdf(event.pathProgram)" 
          class="px-3 py-2 bg-[#E0EEFF] text-[#49BBBD] font-semibold lowercase tracking-wide 
                 rounded-lg hover:bg-[#c8dcff] flex items-center gap-2 shadow-md">
    <span>{{ 'events.program' | translate }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" 
         viewBox="0 0 24 24" stroke="#49BBBD">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
            d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"/>
    </svg>
  </button>

  <!-- Bouton Réserver / Déjà réservé / Événement passé -->
  <ng-container *ngIf="isEventPast(event); else notPast">
    <span class="px-3 py-2 bg-gray-300 text-white font-semibold lowercase tracking-wide 
                 rounded-lg flex items-center gap-2 shadow-md cursor-not-allowed">
      {{ 'events.pastEvent' | translate }}
    </span>
  </ng-container>

  <ng-template #notPast>
    <button *ngIf="!hasReservation(event.id)"
            (click)="reserveEvent(event)"
            class="px-3 py-2 bg-[#49BBBD] text-white font-semibold lowercase tracking-wide 
                   rounded-lg hover:bg-[#3aa3a5] flex items-center gap-2 shadow-md">
      {{ 'actions.reserve' | translate }}
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" 
           viewBox="0 0 24 24" stroke="white">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M12 4v16m8-8H4"/>
      </svg>
    </button>

    <button *ngIf="hasReservation(event.id)"
            disabled
            class="px-3 py-2 bg-gray-300 text-white font-semibold lowercase tracking-wide 
                   rounded-lg flex items-center gap-2 shadow-md cursor-not-allowed">
      {{ 'events.alreadyReserved' | translate }}
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" 
           viewBox="0 0 24 24" stroke="white">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M12 4v16m8-8H4"/>
      </svg>
    </button>
  </ng-template>
</td>



      </tr>
    </tbody>
  </table>
</div>


</div>
